export const RECAPTCHA_SITE_KEY = '6LcXJn0jAAAAACg0n8DpgUsWgS47QaIIUB60IFhR';
export const RECAPTCHA_PLATFORM = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
export const RECAPTCHA_VERIFY_URL =
  'https://data.elfsight.com/public/recaptcha/verify';
